import { render, staticRenderFns } from "./OpportunityPhase.vue?vue&type=template&id=51a61d8e&"
import script from "./OpportunityPhase.vue?vue&type=script&lang=js&"
export * from "./OpportunityPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports